if (!window.APP) {
  window.APP = {};
}
